<script lang="ts">
    import T from "@components/T.svelte";

    import { RewardsTranslationNamespaces } from "../constants/constants";

    //Props
    export let namespace: RewardsTranslationNamespaces;
</script>

<T {namespace} translationKey="points_name_plural" />
